import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme/utils';

export const CATEGORY_GALLERY_NAME = 'CategoryGallery';
export const CATEGORY_GALLERY_SLOTS: Array<keyof CategoryGalleryClasses> = [
	'root',
	'breadcrumbs',
	'content',
] as const;

export type CategoryGallerySlot = (typeof CATEGORY_GALLERY_SLOTS)[number];

export interface CategoryGalleryClasses {
	root: string;
	breadcrumbs: string;
	content: string;
}

export type CategoryGalleryClassKey = keyof CategoryGalleryClasses;

export const getCategoryGalleryUtilityClass = (slot: string) =>
	generateUtilityClass(CATEGORY_GALLERY_NAME, slot as CategoryGallerySlot);

export const categoryGalleryClasses: CategoryGalleryClasses =
	generateUtilityClasses(CATEGORY_GALLERY_NAME, [
		'root',
		'breadcrumbs',
		'content',
	]);

export default categoryGalleryClasses;
